module.exports = __webpack_public_path__ + "static/media/game_cover_archero@768.ff06d5e1.png";